import { FeatureService, type FeatureKey } from '@/services/FeatureService';

// Feature keys (PR-870), replacing the compile-time ASSAYS_UI_ENABLED / MEASUREMENTS_UI_ENABLED
// constants. Safe to read from any setup() or template — the router guard blocks navigation until
// the bootstrap that loads the map resolves. Never at module scope, though: see the doc.
// docs/technical-requirements/feature-flags.md

export type { FeatureKey };

/**
 * True only where the environment explicitly enabled the key. Reactive — it reads the service's
 * underlying ref — so it works directly in a template as well as in script.
 */
export function isFeatureEnabled(key: FeatureKey): boolean {
  return FeatureService.isEnabled(key);
}

/**
 * Route-guard form of the check, here rather than inline in the router so it can be tested without
 * importing the whole route table. A route with no `meta.feature` is always allowed.
 */
export function isRouteFeatureEnabled(meta: { feature?: unknown } | undefined): boolean {
  const key = meta?.feature as FeatureKey | undefined;
  return !key || isFeatureEnabled(key);
}
